import {float, extract} from '../utils.js';

const sphere = ([position, type, dimension, r, g, l, index]) => {
    return {
        args: {
            "p": "vec3",
        },
        returnType: "vec2",
        body: `
return vec2(length(p - ${float(position)}) - ${float(dimension)}.x, ${float(index)});
`
    };
};

export const cappedCylinder = ([position, type, dimension, round, g, l, index, repeat]) => {
    return {
        args: {
            "p": "vec3",
        },
        returnType: "vec2",
        body: `
   p = (p - ${position})*${g}  + (${position})*(${g} - identity);
   p = ${repeatOp(repeat)};
   float h = ${float(dimension)}.x;
   float r = ${float(dimension)}.y;
  vec2 d = abs(vec2(length(p.xz),p.y)) - vec2(h,r);
  return vec2(min(max(d.x,d.y),0.0) + length(max(d,0.0)), ${float(index)});
`
    };
};

export const rect = ([position, type, dimension, round, globalTransformation, localTransformation, index]) => {
    return {
        args: {
            "p": "vec2",
        },
        returnType: "vec2",
        body: `
    return vec2(sdRoundBoxCoord(
        p, 
        ${float(position)}, 
        (${float(dimension)}), 
        ${float(round)},
        ${float(globalTransformation || "identity")}, 
        ${float(localTransformation)}), ${float(index)});
`
    };
};

/**
 * repeat is a 4-component vector with 
 * x: # of repeats
 * y: # of repeats on x axis
 * z: # of repeats on y axis
 * w: # of repeats on z axis
 */
const repeatOp = (repeat) => {
    if (typeof repeat === "object" && Object.keys(repeat).length === 0) {
        return "p";
    }
    return `p - ${float(repeat)}.x *
    clamp(
        round(p/${float(repeat)}.x), 
        -vec3(${float(repeat)}.y, ${float(repeat)}.z, ${float(repeat)}.w), 
        vec3(${float(repeat)}.y, ${float(repeat)}.z, ${float(repeat)}.w))`;
};

export const box =  ([position, type, dimension, round, globalTransformation, localTransformation, index, repeat]) => {
    return {
        args: {
            "p": "vec3",
        },
        returnType: "vec2",
        body: `

  p = (p - ${position})*${globalTransformation}  + (${position})*(${globalTransformation} - identity);
  vec3 q = ${repeatOp(repeat)};
  return vec2(sdRoundBox3DCoord(
        q, 
        ${float(position)}, 
        (${float(dimension)}), 
        ${float(round)}, 
        ${float(globalTransformation || "identity")}, 
        ${float(localTransformation)}), ${float(index)});
`
    };
};


export const circle =  ([position, type, dimension, round, globalTransformation, localTransformation, index, repeat]) => {
    return {
        args: {
            "p": "vec2",
        },
        returnType: "vec2",
        body: `

return vec2(length(p - ${float(position)}) - ${float(dimension)}.x, ${float(index)});
`
    };
};

// r: dimensions of torus (outter radius + inner radius)
export const torus = ([position, type, r, round, g, l, index]) => {
     return {
        args: {
            "p": "vec3",
        },
        returnType: "vec2",
        body: `
    p = (p - ${position})*${g}  + (${position})*(${g} - identity);
    vec3 r = ${r};
    float x = length(p.xz)-r.x;
    return vec2(
        length(vec2(x, p.y)) - r.y, 
        ${float(index)});
`
     };
};

export const plane = ([position, type, dimensions, round, g, l, index]) => {
     return {
        args: {
            "p": "vec3",
        },
        returnType: "vec2",
        body: `
    return vec2(
        dot(p, ${dimensions}) + ${position}.x,
        ${float(index)});
`
     };
};

export const sdf_types = {
    cappedCylinder,
    rect,
    box,
    circle,
    sphere,
    torus,
    plane,
};
